/*
 * import { Box } from "@twilio-paste/core/box";
 * import { ChatIcon } from "@twilio-paste/icons/esm/ChatIcon";
 */
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { useDispatch, useSelector } from "react-redux";

import { changeExpandedStatus } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { containerStyles } from "./styles/EntryPoint.styles";

export const EntryPoint = () => {
  const dispatch = useDispatch();
  const expanded = useSelector((state: AppState) => state.session.expanded);
  const { serverUrl } = useSelector((state: AppState) => state.config)

  console.log('serverUrl', serverUrl)
  function IconeChat() {
    // Import result is the URL of your image
    return <img src={`${serverUrl}/icone_chat.png`} alt="Logo" />;
  }

  return (
    <button
      type="submit"
      data-test="entry-point-button"
      onClick={() => dispatch(changeExpandedStatus({ expanded: !expanded }))}
      style={containerStyles(expanded)}
    >
      {expanded ? (
        <ChevronDownIcon decorative={false} title="Minimize chat" size="sizeIcon60" />
      ) : (
        // <ChatIconSvg/>
        <IconeChat />
      )}
    </button>
  );
};
